export const LOAD_EMENDAS = 'LOAD_EMENDAS'
export const CLEAR_EMENDAS = 'CLEAR_EMENDAS'
export const SET_YEAR = 'SET_YEAR'
export const EMENDAS_TOGGLE_LOADING = 'EMENDAS_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/emendas_parlamentares/types.js